import React from "react";
import { Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "../hooks/useTranslation";
import {
  EXTRACTION_MODE_NEXT_SET26,
  normalizeExtractionMode,
} from "../constants/extractionModes";

/* Mesmo desenho do chip de modo da contestação (ContestacaoDrawerSections),
   com o destaque invertido: aqui quem ganha a cor da marca é o modo novo
   (Next-Set26), não o legado. */
const useStyles = makeStyles((theme) => ({
  modeChip: {
    height: 22,
    fontSize: "0.72rem",
    fontWeight: 600,
    letterSpacing: "0.3px",
    "& .MuiChip-label": {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  modeStandard: {
    backgroundColor: "var(--ikaro-bg-surface-secondary)",
    color: "var(--ikaro-text-primary)",
    border: "1px solid var(--ikaro-border-default)",
  },
  modeNextSet26: {
    backgroundColor: "var(--ikaro-orange-light)",
    color: "var(--ikaro-orange-primary)",
    border: "1px solid var(--ikaro-orange-primary)",
  },
}));

/**
 * Chip do modo de extração de um job de PDF. Usado na coluna da tabela de
 * processamentos, no drawer de detalhes e na célula de input da tela de
 * Status de Tarefas.
 *
 * `mode` é o valor cru da API (`input_params.extraction_mode`); a
 * normalização acontece aqui para os três call sites não repetirem.
 */
const ExtractionModeChip = ({ mode, className = "" }) => {
  const classes = useStyles();
  const { t } = useTranslation("jobs");

  const normalized = normalizeExtractionMode(mode);
  const isNext = normalized === EXTRACTION_MODE_NEXT_SET26;

  /* defaultValue explícito (em vez da string solta que o chip da contestação
     usa): um modo que a UI ainda não conheça aparece com o valor cru em vez
     de vazar a chave de tradução. O hífen de `next-set26` é seguro na chave —
     o separador do i18next é o ponto. */
  const label = t(`processings.modeLabels.${normalized}`, {
    defaultValue: normalized,
  });

  return (
    <Chip
      size="small"
      label={label}
      className={`${classes.modeChip} ${
        isNext ? classes.modeNextSet26 : classes.modeStandard
      } ${className}`}
    />
  );
};

export default ExtractionModeChip;
